import { combineReducers } from 'redux';

import StatusReducer from './reducers/status.reducer';
import SessionReducer from './reducers/session.reducer';
import MessageReducer from './reducers/message.reducer';
import RuleReducer from './reducers/rule.reducer';
import OriginalDataReducer from './reducers/original-data.reducer';
import MutatedDataReducer from './reducers/mutated-data.reducer';
import JoinReducer from './reducers/join.reducer';
import MetaDataReducer from './reducers/metadata.reducer';
import SettingsReducer from './reducers/settings.reducer';

const RootReducer = combineReducers({
  status: StatusReducer,
  messaging: MessageReducer,
  metadata: MetaDataReducer,
  rules: RuleReducer,
  originalData: OriginalDataReducer,
  mutatedData: MutatedDataReducer,
  joins: JoinReducer,
  sessions: SessionReducer,
  settings: SettingsReducer
});

export default RootReducer;
